module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header', {
    attrs: {
      "icon": "user"
    }
  }, [_vm._v("\n        Profil\n    ")]), _vm._v(" "), _c('action-bar', {
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('a', {
    staticClass: "btn add btn-full",
    attrs: {
      "id": "main-action",
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  }), _vm._v(" "), _c('strong', [_vm._v("Déconnexion")])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content profil"
  }, [_c('div', {
    staticClass: "head wrap"
  }, [_c('div', {
    staticClass: "img-profil",
    style: ('background-image: url(' + _vm.photoProfil + ')')
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v(_vm._s(_vm.user.first_name) + "\n                    "), _c('strong', [_vm._v(_vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('h3', [_vm._v("Technicien")])])]), _vm._v(" "), _c('form', {
    staticClass: "change-pdp",
    attrs: {
      "method": "post"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "hidden",
      "name": "change-photo-profil"
    }
  })]), _vm._v(" "), _c('input', {
    ref: "photoInput",
    staticClass: "hidden",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "photo-profil"
    },
    on: {
      "change": _vm.updatePhoto
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "prev-photo-profil"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-sign wrap"
  }, [_c('a', {
    staticClass: "btn btn-full",
    attrs: {
      "id": "photo-trigger",
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.triggerPhoto
    }
  }, [_c('i', {
    staticClass: "icon-photo"
  }), _vm._v(" "), _c('span', [_vm._v("Photo ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-full toggle-modal",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "icon-contract"
  }), _vm._v(" "), _c('span', [_vm._v("Signature")])])]), _vm._v(" "), _c('div', {
    staticClass: "infos-user wrap"
  }, [_c('ul', {
    staticClass: "wrap"
  }, [_c('li', [_c('i', {
    staticClass: "icon-email"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-phone"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.type !== 'magasinier'),
      expression: "user.type !== 'magasinier'"
    }]
  }, [_c('i', {
    staticClass: "icon-car"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.user.immatriculation))])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-full edit",
    attrs: {
      "id": "edit-profil",
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        _vm.showFormUser = true
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })])]), _vm._v(" "), (_vm.user.type !== 'magasinier') ? _c('section', {
    staticClass: "certificats"
  }, [_c('h3', [_vm._v("Mon attestation d'aptitude")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-valid"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.user.attestation_aptitude))])])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('signature-modal', {
    attrs: {
      "signature": _vm.user.signature64
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "signatureUpdated": _vm.updateSignature
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFormUser),
      expression: "showFormUser"
    }],
    staticClass: "modal-infos",
    on: {
      "closeForm": function($event) {
        _vm.showFormUser = false
      }
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('h1', [_c('strong', [_vm._v("Modifier ")]), _vm._v("mes informations\n                ")]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    }
  }, [_c('cleave', {
    ref: "telephone",
    attrs: {
      "options": _vm.telOpt,
      "type": "text",
      "name": "numtel",
      "placeholder": "Téléphone portable",
      "inputmode": "tel"
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.type !== 'magasinier'),
      expression: "user.type !== 'magasinier'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.immatriculation),
      expression: "user.immatriculation"
    }],
    attrs: {
      "type": "text",
      "name": "immat",
      "placeholder": "Immatriculation vehicule",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.user.immatriculation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "immatriculation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "warning-info"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.saveInfos
    }
  }, [_vm._v("SAUVEGARDER")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)])]), _vm._v(" "), _c('a', {
    staticClass: "profil-lien",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.askSendData($event)
      }
    }
  }, [_vm._v("\n            Envoyer mes données au support\n        ")]), _vm._v(" "), (_vm.isDemo === true) ? _c('a', {
    staticClass: "profil-lien fixed-bottom-btn",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.askDeleteData($event)
      }
    }
  }, [_vm._v("\n            Demander une suppression de mes données\n        ")]) : _vm._e(), _vm._v(" "), (this.user.operator && this.user.operator.id === 5) ? _c('a', {
    staticClass: "profil-lien",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.askDeleteDonnee($event)
      }
    }
  }, [_vm._v("\n            DEBUG : Supprimer les données\n        ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae05d3fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Profil.vue
// module id = 782
// module chunks = 0